export default __webpack_public_path__ + "static/media/编组 9.f172f304.png";